<app-spinner [loading]="saving()"></app-spinner>
<form [formGroup]="form" class="profile-form" appFormFields>
  <h1 class="profile-form__title">{{ title() }}</h1>
  <div class="profile-form__body">
    <div class="profile-form__inputs">
      <app-form-field
        [name]="ProfileFormField.profileName"
        class="profile-form__profileName"
      ></app-form-field>
      <app-form-field [name]="ProfileFormField.profileType"></app-form-field>
      <div
        [matTooltip]="
          form.controls.ca.disabled ? labels.disabledCaTooltip : undefined
        "
      >
        <app-form-field
          [name]="ProfileFormField.ca"
          [options]="caOptions()"
        ></app-form-field>
      </div>
      <div class="profile-form__maxcertvalidity">
        <div>{{ labels.maxCertificateValidity }}</div>
        <app-form-field
          [name]="ProfileFormField.maxCertificateValidityYears"
          [errorStateMatcher]="allZerosErrorStateMatcher"
        >
        </app-form-field>
        <app-form-field
          [name]="ProfileFormField.maxCertificateValidityMonths"
          [errorStateMatcher]="allZerosErrorStateMatcher"
        >
        </app-form-field>
        <app-form-field
          [name]="ProfileFormField.maxCertificateValidityDays"
          [errorStateMatcher]="allZerosErrorStateMatcher"
        >
        </app-form-field>
      </div>
      <div class="profile-form__oids">
        <h2 class="profile-form__oidstitle">
          {{ labels.overridableExtensionOIDsTitle }}
        </h2>
        @for (
          control of form.controls.overridableExtensionOIDs.controls;
          track control
        ) {
          <app-form-field
            [name]="ProfileFormField.overridableExtensionOIDs"
            [path]="[ProfileFormField.overridableExtensionOIDs, $index]"
          ></app-form-field>
          <button
            type="button"
            mat-icon-button
            [matTooltip]="labels.removeOverridableExtensionOIDs"
            (click)="onRemoveOids($index)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
        <div class="create-ca__add-oids">
          <button type="button" mat-button class="button" (click)="onAddOids()">
            {{ labels.addOverridableExtensionOIDs }}
          </button>
        </div>
      </div>
      <div class="profile-form__checkboxes">
        <app-form-field
          [name]="ProfileFormField.allowExtensionOverride"
        ></app-form-field>
        <app-form-field
          [name]="ProfileFormField.criticalBasicConstraints"
        ></app-form-field>
      </div>
      <app-form-field
        [name]="ProfileFormField.keyUsages"
        class="profile-form__keyusages"
      ></app-form-field>
      <app-form-field
        [name]="ProfileFormField.extendedKeyUsages"
        class="profile-form__keyusages"
      ></app-form-field>
      <app-form-field
        [name]="ProfileFormField.crlDistributionEndpoint"
      ></app-form-field>
      <app-form-field
        [name]="ProfileFormField.criticalCRLDistributionPoint"
      ></app-form-field>
      <app-form-field
        [name]="ProfileFormField.pathLengthConstraint"
      ></app-form-field>
      <app-form-field
        [name]="ProfileFormField.useLastToFirstDnOrder"
      ></app-form-field>
    </div>
    <app-form-field
      [name]="ProfileFormField.ocspServiceLocator"
      class="profile-form__ocspServiceLocator"
    >
    </app-form-field>
    <div class="profile-form__buttons">
      <button type="button" mat-button class="button" (click)="onCancel()">
        {{ labels.buttons.cancel }}
      </button>
      @if (edit()) {
        <button
          type="submit"
          mat-button
          class="button button_primary"
          (click)="onUpdate()"
        >
          {{ labels.buttons.update }}
        </button>
      } @else {
        <button
          type="submit"
          mat-button
          class="button button_primary"
          (click)="onCreate()"
        >
          {{ labels.buttons.create }}
        </button>
      }
    </div>
  </div>
</form>
